module.exports = __webpack_public_path__ + "static/media/monster_card_back.1c2fbc78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Monsters/monster_card_back.jpg
// module id = 210
// module chunks = 0